import { render, staticRenderFns } from "./ANxALxLaborPage.vue?vue&type=template&id=86f38560"
import script from "./ANxALxLaborPage.vue?vue&type=script&lang=js"
export * from "./ANxALxLaborPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports